import { ApplicationConfig, APP_INITIALIZER } from '@angular/core';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { routes } from './app.routes';
import { authInterceptor } from './core/auth/auth.interceptor';
import { errorInterceptor } from './core/http/error.interceptor';
import { AuthService } from './core/auth/auth.service';
import { MarquesStore } from './modules/marques/marques.store';
import { TraitesStore } from './modules/traites/traites.store';

function initializeApp(
  authService: AuthService,
  marquesStore: InstanceType<typeof MarquesStore>,
  traitesStore: InstanceType<typeof TraitesStore>,
) {
  return async () => {
    await authService.initialize();
    // Précharger les données de référence dès la connexion (fire-and-forget)
    if (authService.isAuthenticated) {
      marquesStore.loadAllMarques();
      traitesStore.loadCodesMarque();
    }
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideOAuthClient(),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AuthService, MarquesStore, TraitesStore],
      multi: true,
    },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        duration: 4000,
        horizontalPosition: 'end',
        verticalPosition: 'bottom',
      },
    },
  ],
};
